const HTML_TAG_ALLOWLIST =
  /^(html|head|body|page|div|span|p|a|img|br|hr|meta|link|script|style|h[1-6]|ul|ol|li|table|thead|tbody|tfoot|tr|td|th|form|input|button|select|option|textarea|label|strong|em|b|i|u|s|sub|sup|pre|code|blockquote|article|section|header|footer|nav|main|aside|figure|figcaption|details|summary|mark|time|small|del|ins|abbr|address|cite|dfn|kbd|samp|var|wbr)$/i;

export const looksLikeHtml = (content: string): boolean => {
  const tagPattern = /<\/?([a-z][a-z0-9]*)\b[^>]*\/?>/gi;
  let match: RegExpExecArray | null;

  while ((match = tagPattern.exec(content)) !== null) {
    const tagName = match[1];

    if (tagName && HTML_TAG_ALLOWLIST.test(tagName)) {
      return true;
    }
  }

  return false;
};
